import { createSlice } from "@reduxjs/toolkit"
import {
  addBulkCoupon,
  addCoupon,
  addCouponGroup,
  addPromotion,
  deleteCoupon,
  deleteCouponGroup,
  deletePromotion,
  getAllCouponUsage,
  getAllCoupons,
  getAllCouponsGroup,
  getAllCouponsGroupsList,
  getAllCouponsList,
  getAllPromotions,
  getAllPromotionsList,
  getCouponDetails,
  getCouponGroupDetails,
  getCouponUsageDetails,
  getPromotionDetails,
  updateBulkCouponGroup,
  updateCoupon,
  updateCouponGroup,
  updateCouponGroupStatus,
  updateCouponStatus,
  updatePromotion,
  updatePromotionStatus,
} from "store/actions/promotionsAction"

const initialState = {
  loading: true,
  itemsPerPage: 20,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  promotions: [],
  promotionsList: [],
  promotionDetails: {},
  isLoading: false,
  isUpdating: false,
  couponsGroups: [],
  couponsGroupsList: [],
  couponGroupDetails: {},
  couponGroupLoading: false,
  couponLoading: false,
  coupons: [],
  couponsLists: [],
  couponDetails: {},
  couponUsage: [],
  couponUsageDetails: {},
  couponsItemsPerPage: 10,
}

const usersSlice = createSlice({
  name: "promotions",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL PROMOTIONS
    builder
      .addCase(getAllPromotions.pending, state => {
        state.loading = true
      })
      .addCase(getAllPromotions.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action?.payload
          state.promotions = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllPromotions.rejected, (state, action) => {
        state.loading = false
      })

    // GET ALL PROMOTIONS List
    builder
      .addCase(getAllPromotionsList.pending, state => {
        state.loading = true
      })
      .addCase(getAllPromotionsList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.promotionsList = data
        }
      })
      .addCase(getAllPromotionsList.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE PROMOTION STATUS
    builder
      .addCase(updatePromotionStatus.pending, state => {
        state.isUpdating = true
      })
      .addCase(updatePromotionStatus.fulfilled, (state, action) => {
        state.isUpdating = false
        const { status } = action.payload || {}
        if (status) {
          const { id, status } = action.meta.arg
          state.promotions = state.promotions.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updatePromotionStatus.rejected, (state, action) => {
        state.isUpdating = false
      })

    //   DELETE PROMOTION
    builder
      .addCase(deletePromotion.pending, state => {
        state.isLoading = true
      })
      .addCase(deletePromotion.fulfilled, (state, action) => {
        const { status, msg } = action.payload || {}
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.promotions = state.promotions.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deletePromotion.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD PROMOTION
    builder
      .addCase(addPromotion.pending, state => {
        state.isLoading = true
      })
      .addCase(addPromotion.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addPromotion.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET PROMOTION DETAILS
    builder
      .addCase(getPromotionDetails.pending, state => {
        state.loading = true
        state.promotionDetails = {}
      })
      .addCase(getPromotionDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.promotionDetails = data
        }
      })
      .addCase(getPromotionDetails.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE PROMOTION
    builder
      .addCase(updatePromotion.pending, state => {
        state.isLoading = true
      })
      .addCase(updatePromotion.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updatePromotion.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET ALL COUPONS GROUPS:
    builder
      .addCase(getAllCouponsGroup.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getAllCouponsGroup.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action?.payload
          state.couponsGroups = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllCouponsGroup.rejected, (state, action) => {
        state.loading = false
      })

    // GET ALL COUPONS GROUPS LIST
    builder
      .addCase(getAllCouponsGroupsList.pending, state => {})
      .addCase(getAllCouponsGroupsList.fulfilled, (state, action) => {
        const { status, data } = action.payload || {}
        if (status) {
          state.couponsGroupsList = data
        }
      })
      .addCase(getAllCouponsGroupsList.rejected, (state, action) => {})

    // UPDATE COUPON GROUP STATUS
    builder
      .addCase(updateCouponGroupStatus.pending, state => {
        state.isUpdating = true
      })
      .addCase(updateCouponGroupStatus.fulfilled, (state, action) => {
        state.isUpdating = false
        const { status } = action.payload || {}
        if (status) {
          const { id, status } = action.meta.arg
          state.couponsGroups = state.couponsGroups.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateCouponGroupStatus.rejected, (state, action) => {
        state.isUpdating = false
      })

    //   DELETE COUPON GROUP
    builder
      .addCase(deleteCouponGroup.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteCouponGroup.fulfilled, (state, action) => {
        const { status, msg } = action.payload || {}
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.couponsGroups = state.couponsGroups.filter(
            item => item._id !== id
          )
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteCouponGroup.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD COUPON GROUP
    builder
      .addCase(addCouponGroup.pending, state => {
        state.isLoading = true
      })
      .addCase(addCouponGroup.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          if (data) {
            state.couponsGroups.push(data)
            // Increment the totalCount if it exists
            if (state.totalCount !== null) {
              state.totalCount += 1
            }
          }
        }
      })
      .addCase(addCouponGroup.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET COUPON LIST
    builder
      .addCase(getAllCouponsList.pending, state => {
        state.isLoading = true
      })
      .addCase(getAllCouponsList.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.couponsLists = data
        }
      })
      .addCase(getAllCouponsList.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET COUPON GROUP DETAILS
    builder
      .addCase(getCouponGroupDetails.pending, state => {
        state.couponGroupLoading = true
        state.couponGroupDetails = {}
      })
      .addCase(getCouponGroupDetails.fulfilled, (state, action) => {
        state.couponGroupLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.couponGroupDetails = data
        }
      })
      .addCase(getCouponGroupDetails.rejected, (state, action) => {
        state.couponGroupLoading = false
      })

    // UPDATE COUPON GROUP
    builder
      .addCase(updateCouponGroup.pending, state => {
        state.isLoading = true
      })
      .addCase(updateCouponGroup.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload || {}
        const {
          _id,
          name,
          nameAr,
          status: updatedStatus,
        } = action?.payload?.data
        if (status) {
          const { id, name, nameAr } = action.meta.arg
          state.couponsGroups = state.couponsGroups.map(item =>
            item._id === id
              ? { ...item, _id, name, nameAr, status: updatedStatus }
              : item
          )
        }
      })
      .addCase(updateCouponGroup.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPDATE BULK COUPON GROUP
    builder
      .addCase(updateBulkCouponGroup.pending, state => {
        state.isLoading = true
      })
      .addCase(updateBulkCouponGroup.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload || {}
      })
      .addCase(updateBulkCouponGroup.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET ALL COUPONS:
    builder
      .addCase(getAllCoupons.pending, state => {
        state.couponLoading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
        state.coupons = []
      })
      .addCase(getAllCoupons.fulfilled, (state, action) => {
        state.couponLoading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action?.payload
          state.coupons = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllCoupons.rejected, (state, action) => {
        state.couponLoading = false
      })

    // UPDATE COUPON GROUP STATUS
    builder
      .addCase(updateCouponStatus.pending, state => {
        state.isUpdating = true
      })
      .addCase(updateCouponStatus.fulfilled, (state, action) => {
        state.isUpdating = false
        const { status } = action.payload || {}
        if (status) {
          const { id, status } = action.meta.arg
          state.coupons = state.coupons.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateCouponStatus.rejected, (state, action) => {
        state.isUpdating = false
      })

    //   DELETE COUPON GROUP
    builder
      .addCase(deleteCoupon.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteCoupon.fulfilled, (state, action) => {
        const { status, msg } = action.payload || {}
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.coupons = state.coupons.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteCoupon.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD COUPON
    builder
      .addCase(addCoupon.pending, state => {
        state.isLoading = true
      })
      .addCase(addCoupon.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addCoupon.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET COUPON DETAILS
    builder
      .addCase(getCouponDetails.pending, state => {
        state.loading = true
        state.couponDetails = {}
      })
      .addCase(getCouponDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.couponDetails = data
        }
      })
      .addCase(getCouponDetails.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE COUPON
    builder
      .addCase(updateCoupon.pending, state => {
        state.isLoading = true
      })
      .addCase(updateCoupon.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateCoupon.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD BULK COUPON
    builder
      .addCase(addBulkCoupon.pending, state => {
        state.isLoading = true
      })
      .addCase(addBulkCoupon.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addBulkCoupon.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET ALL COUPONS:
    builder
      .addCase(getAllCouponUsage.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getAllCouponUsage.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action?.payload
          state.couponUsage = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllCouponUsage.rejected, (state, action) => {
        state.loading = false
      })

    // GET COUPON GROUP DETAILS
    builder
      .addCase(getCouponUsageDetails.pending, state => {
        state.loading = true
        state.couponUsageDetails = {}
      })
      .addCase(getCouponUsageDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {} 
        if (status) {
          state.couponUsageDetails = data
        }
      })
      .addCase(getCouponUsageDetails.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export default usersSlice.reducer
